import Mark from "./Mark.ts";
import MarkText from "../components/MarkText.ts";
import {Container, Graphics, Sprite, Text, TextStyle} from "pixi.js";
import IMark from "../interfaces/IMark.ts";
import DecodingModel from "../models/DecodingModel.ts";
import RhColors from "@/models/RhColors.ts";

export default class SoundOfLongAMark extends Mark implements IMark
{
    public get targetX():number
    {
        if(this._targetX == undefined)
        {
            if(this.targetTextField)
            {
                this._targetX = 0;
            }
            else
            {
                this._targetX = 0;
            }
        }
        return this._targetX;
    }

    public get targetY():number
    {
        if(this._targetY == undefined)
        {
            if(this.targetTextField)
            {
                this._targetY = this.targetTextField.y;
            }
            else
            {
                this._targetY = 0;
            }
        }
        return this._targetY;
    }

    constructor(targetTextField?:MarkText, color=RhColors.MARK_PRIMARY)
    {
        super(color);
        this.targetTextField = targetTextField;
        this._init();
    }

    private _init():void
    {
        this.strokeThickness = 5;
        if(this.targetTextField)
        {
            this.parentTarget = this.targetTextField;
        }
    }

    private createMark(color:string=this.color, visible:boolean=true):Graphics | Sprite | Text | Container
    {
        const markXOffset: number = 0;
        const markYOffset: number = -25;
        let graphicsW = 20;
        const graphicsH = 10;
        const divisorW = 5;
        const divisorH = 2.9;

        let mark = new Container();

        let gr = new Graphics();
        gr.moveTo(markXOffset, markYOffset + this.strokeThickness / 2);
        gr.lineTo(markXOffset + graphicsW, markYOffset + this.strokeThickness / 2);
        gr.stroke({width:this.strokeThickness, color:color, cap:"round"});
        gr.x = (this.markWidth / 2) - (graphicsW / 2);
        mark.addChild(gr);

        const style = new TextStyle({
            fontFamily: DecodingModel.getInstance().fontFamily,
            fontSize: 40,
            fill: color,
            align: 'center'
        });
        const letter = new Text({text:"a", style:style});
        letter.x = (this.markWidth / 2) - (letter.width / 2);
        letter.y = -(letter.height / 1.5);
        mark.addChild(letter);

        graphicsW = 85;
        gr = new Graphics();
        gr.moveTo(0, graphicsH);
        gr.bezierCurveTo(graphicsW/divisorW, -(this.markHeight/divisorH), graphicsW-(graphicsW/divisorW), -(this.markHeight/divisorH), graphicsW, graphicsH);
        gr.stroke({width:this.strokeThickness, color:color, cap:"round"});
        gr.x = (this.markWidth / 2) - (graphicsW / 2);
        gr.y = 26;
        mark.addChild(gr);

        mark.visible = visible;
        this.addChild(mark);
        //mark.cacheAsBitmap = true;
        return mark;
    }

    public override create():void
    {
        this.createMarks();
    }

    public createMarks()
    {
        this.mark = this.createMark();
        this.markHighlight = this.createMark(this.highlightColor, false);
    }

}